import {
  ASSETS_ICONS_FALLBACK_URL,
  ASSETS_ICONS_MAP,
} from "@tradingApp/components/shared/AssetIcon/constants";
import { STATIC_DROPSTAB_BASE_URL } from "@tradingApp/constants";

export function getAssetIconUrl(asset?: string): string {
  if (!asset) {
    return ASSETS_ICONS_FALLBACK_URL;
  }

  const filename = ASSETS_ICONS_MAP[asset as keyof typeof ASSETS_ICONS_MAP];

  if (!filename) {
    console.warn(`Asset icon not found for asset: ${asset}`);
  }

  return filename
    ? `${STATIC_DROPSTAB_BASE_URL}/images/${filename}`
    : ASSETS_ICONS_FALLBACK_URL;
}
